import { Services } from '@sigma-frontend-libs/commons'

import { generateServices, permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'SecondCol',

  mixins: [
    generateServices({
      name: Services['url-shortener-tracking'],

      backendGeneration: 'nest',

      find: {
        defaultFilter: {
          shortUrlId: undefined,
          clientIp: undefined
        },
        defaultPagination: {
          limit: 10
        }
      },

      get: false,
      create: false,
      update: false,
      remove: false
    })
  ],

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      tab: undefined,

      item: undefined,

      clientIp: undefined,

      showDialog: false
    }
  },

  computed: {
    canGet() {
      return this.checkPermissions(`advanced.${Services['url-shortener-tracking']}.get`, permissionPresets.meUp)
    },

    tabs() {
      const result = []
      if (this.canGet) {
        result.push(Services['url-shortener-tracking'])
      }

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`${key}.title`)
        }
      })
    }
  },

  watch: {
    clientIp(value) {
      this.restData[Services['url-shortener-tracking']].find.filter.clientIp = value
    }
  },

  mounted() {
    if (this.value?.id) {
      this.restData[Services['url-shortener-tracking']].find.filter.shortUrlId = this.value.id
      this.rest[Services['url-shortener-tracking']].find()
    }
  },

  render
}
